
import Vue from 'vue';
import {statsInterface} from "~/components/index/references.vue";

export default Vue.extend({
  name: 'contactCard',
  async fetch() {
    this.stats = await this.$axios.$get('/v1/stats').then(data => data.data)
  },
  data(): { images: string[], stats: statsInterface } {
    return {
      stats: {
        review_amount: 0,
        review_score: 0,
        chef_amount: 0,
        listing_amount: 0
      },
      images: [],
    }
  }
})
